<template>
    <div class="create-ticket-wrap">
        <!-- <div class="page-title">创建工单</div> -->
        <!-- 外层容器通栏背景100%宽，内部步骤条40%靠左摆放 -->
        <div class="steps-wrap">
            <el-steps :active="stepIndex" size="small" simple class="tiny-step">
                <el-step title="选择问题类型"></el-step>
                <el-step title="填写工单信息"></el-step>
            </el-steps>
        </div>

        <!-- 第一步：选择问题类型 -->
        <div v-if="stepIndex === 0" class="step-type">
            <div class="sub-title">选择问题类型</div>
            <div class="type-grid">
                <div v-for="item in typeList" :key="item.id" class="type-card"
                    :class="{ active: selectType.id === item.id }" @click="selectType = item">
                    <div class="card-icon">
                        <i class="el-icon-circle-check"></i>
                    </div>
                    <div class="card-name">{{ item.dictionary_name }}</div>
                    <div class="card-desc">{{ item.remark }}</div>
                </div>
            </div>

            <div class="btn-group" style="margin-top:20px;">
                <el-button size="small" @click="step_cancel">取消</el-button>
                <el-button size="small" type="primary" :disabled="!selectType.id" @click="nextStep">下一步</el-button>
            </div>
        </div>

        <!-- 第二步：填写工单表单 -->
        <div v-if="stepIndex === 1" class="step-form">
            <el-form ref="form" :model="form" label-width="200px" :rules="rules" size="small" style="width:750px;">
                <el-form-item label="已选问题类型">
                    <el-input size="small" v-model="form.ticket_type_name" disabled></el-input>
                </el-form-item>

                <el-form-item label="工单标题" prop="title">
                    <el-input size="small" v-model="form.title" placeholder="请输入工单标题"></el-input>
                </el-form-item>

                <el-form-item label="问题单号/订单号/商品ID" prop="effect_no">
                    <el-input size="small" v-model="form.effect_no" placeholder="如有相关订单/账单单号/商品ID请填写"></el-input>
                </el-form-item>

                <el-form-item prop="user_mobile">
                    <template slot="label">
                        <span>星好货账号</span>
                        <el-tooltip content="当前账号问题，可不填写" placement="top" effect="dark">
                            <i class="el-icon-question" style="margin-left:2px;cursor:pointer;"></i>
                        </el-tooltip>
                    </template>
                    <el-input size="small" v-model="form.user_mobile" placeholder="请输入星好货账号"></el-input>
                </el-form-item>

                <el-form-item label="问题详细描述" prop="content">
                    <el-input size="small" v-model="form.content" type="textarea" :rows="5"
                        placeholder="详细描述你的问题、操作步骤、报错信息"></el-input>
                </el-form-item>

                <el-form-item label="凭证附件">
                    <!-- <el-upload action="/api/upload/file" multiple list-type="text" size="small"
                        :on-success="uploadSuccess">
                        <el-button size="mini">上传截图、凭证</el-button>
                        <div slot="tip" class="el-upload__tip" style="font-size:12px;">支持图片、PDF，单文件5M以内</div>
                    </el-upload> -->
                    <el-upload class="no-broken-img" ref="attachments" style="display: inline-block;"
                        list-type="picture" :http-request="uploadAttachment"
                        :on-success="handleUploadSuccess" :on-change="handleUploadChange" :limit="10"
                        :file-list="fileList" :on-preview="handleOpen" :on-remove="handleUploadRemove"
                        :before-upload="beforeUpload" :disabled="batchUploading">
                        <el-button type="primary" size="small" :loading="batchUploading" :disabled="batchUploading">
                            {{ batchUploading ? '上传中...' : `批量上传` }}
                        </el-button>
                        <div slot="tip" class="el-upload__tip">支持
                            jpg/jpeg/png/pdf/doc/docx/xls/xlsx/txt，单文件最大5MB，最多上传10个</div>
                    </el-upload>
                </el-form-item>

                <!-- <el-form-item label="企业/个人名称" prop="contact_name">
                    <el-input size="small" v-model="form.contact_name"></el-input>
                </el-form-item>

                <el-form-item label="联系手机号" prop="contact_mobile">
                    <el-input size="small" v-model="form.contact_mobile"></el-input>
                </el-form-item>

                <el-form-item label="联系邮箱">
                    <el-input size="small" v-model="form.contact_email"></el-input>
                </el-form-item> -->
            </el-form>

            <div class="btn-group" style="margin-top:20px;">
                <el-button size="small" @click="prevStep">上一步</el-button>
                <el-button size="small" type="primary" @click="submitForm">提交工单</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { createDirectUploadRequest } from "@/assets/js/utils/ossDirectUpload";
export default {
    data() {
        return {
            stepIndex: 0,
            selectType: { id: 0, dictionary_name: '', remark: '' },
            typeList: [],
            form: {
                ticket_type: 0,
                ticket_type_name: '',
                title: '',
                effect_no: '',
                user_mobile: '',
                content: '',
                attachments: [],
                // contact_name: '',
                // contact_mobile: '',
                // contact_email: ''
            },
            rules: {
                title: [{ required: true, message: '请填写工单标题', trigger: 'blur' }],
                content: [{ required: true, message: '请描述问题详情', trigger: 'blur' }],
            },
            batchUploading: false,
            fileList: [],
            currentPreviewUrl: '',
            currentPreviewUrlList: [],
        }
    },
    methods: {
        ...mapActions({
            opGetDictionaryWords: 'ucenter/opGetDictionaryWords',
            opSaveUserTicket: 'ucenter/opSaveUserTicket',
        }),
        initData() {
            this.getDictionaryWords();
        },
        getDictionaryWords() {
            this.opGetDictionaryWords({
                data: { 'dictionary_type': 4 },
                success: (res) => {
                    if (res.code == 200) {
                        let list = res.data || [];
                        this.typeList = list;
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        nextStep() {
            this.stepIndex = 1
            this.form.ticket_type = this.selectType.id
            this.form.ticket_type_name = this.selectType.dictionary_name
        },
        prevStep() {
            this.stepIndex = 0
        },
        uploadSuccess(res) {
            if (res.code === 200) {
                this.form.attachments.push(res.data.url)
                this.$message.success('上传成功')
            } else {
                this.$message.error(res.msg || '上传失败')
            }
        },
        submitForm() {
            this.$refs.form.validate(async valid => {
                if (!valid) return
                try {
                    const params = {
                        ...this.form
                    }
                    this.opSaveUserTicket({
                        data: params,
                        success: (res) => {
                            if (res.code == 200) {
                                this.$message.success('工单反馈成功')
                                this.$emit('check_add', 2)
                            } else {
                                this.$message.error(res.message)
                            }

                        }
                    })
                } catch (err) {
                    this.$message.error('提交失败')
                    console.error(err)
                }
            })
        },
        step_cancel() {
            this.$emit('check_add', 2)
        },
        beforeUpload(file) {
            // 限制格式示例，按需开启
            const allowType = [// 图片
                'image/jpeg',
                'image/jpg',
                'image/png',
                // PDF
                'application/pdf',
                // Word
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                // Excel
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                // TXT 文本
                'text/plain'];
            if (!allowType.includes(file.type)) {
                this.$message.error('仅支持 jpg、png、pdf、word、excel、txt 格式');
                return false;
            }

            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                this.$message.error('文件大小不能超过 5MB！');
                return false;
            }
            return true;
        },
        handleUploadSuccess(res, file) {
            if (res.code == 200) {
                const url = res?.data?.url ?? '';
                if (url == '') {
                    this.$message.error('文件上传失败')
                }
                this.form.attachments = this.form.attachments || []
                const hasExist = this.form.attachments.some(item => item.url === url);
                if (!hasExist) {
                    let fileinfo = { url: res?.data?.url ?? '', object_name: res?.data?.object_name ?? '', suffix: res?.data?.suffix ?? '', storage_path: res?.data?.storage_path ?? '' }
                    this.form.attachments.push(fileinfo);
                } else {
                    this.$message.error('文件已上传过，请上传其他图片')
                }
            } else {
                this.$message.error('文件上传失败')
            }
            this.batchUploading = false;

        },
        uploadAttachment(options) {
            createDirectUploadRequest(options, { purpose: 'attachment' });
        },
        handleUploadRemove(file, fileList) {
            // 1. 从上传文件列表中移除当前文件（页面立刻消失）
            const idx = fileList.findIndex(f => f.uid === file.uid)
            if (idx > -1) {
                fileList.splice(idx, 1)
            }
            // 先收集当前页面所有有效 url
            const existUrls = fileList.map(item => item.url).filter(Boolean);

            // 过滤：只保留 url 还在 existUrls 里的对象
            this.form.attachments = this.form.attachments.filter(item => {
                return item && item.url && existUrls.includes(item.url);
            });
        },
        // 批量上传开始
        handleUploadChange(file) {
            if (file.status === 'ready') {
                this.batchUploading = true
            }
        },
        // 判断是否为图片
        isImage(url) {
            if (!url) return false
            const ext = url.split('.').pop().toLowerCase()
            return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
        },

        // 点击文件名
        handleOpen(item) {
            const { url, name } = item
            if (!url) return

            if (this.isImage(url)) {
                this.currentPreviewUrl = ''
                this.currentPreviewUrlList = []
                this.$nextTick(() => {
                    this.currentPreviewUrl = url
                    this.currentPreviewUrlList.push(this.currentPreviewUrl)
                    this.$nextTick(() => {
                        const img = this.$refs.globalImg
                        if (img && img.clickHandler) {
                            img.clickHandler()
                        }
                    })
                })
            } else {
                // 非图片：下载文件
                const a = document.createElement('a')
                a.href = url
                a.download = name
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
        },
        getImageUrls(list) {
            const arr = Array.isArray(list) ? list : []
            return arr.filter(item => this.isImage(item?.url)).map(item => item.url)
        },

        // 打开图片预览（支持多张，从当前点击索引开始）
        openImgPreview(imgList, startIndex) {
            this.currentPreviewUrl = imgList[startIndex]
            this.currentPreviewUrlList = imgList
            this.$nextTick(() => {
                // 触发 el-image 预览
                this.$refs.globalImg?.clickHandler?.()
            })
        }
    }
}
</script>

<style scoped>
.page-title {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 8px;
}

.sub-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 16px;
}

.type-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
}

.type-card {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 12px;
    cursor: pointer;
    transition: all 0.2s;
}

.type-card:hover {
    border-color: #409eff;
    background-color: #f5faff;
}

.type-card.active {
    border-color: #409eff;
    background-color: #f0f7ff;
}

.card-icon {
    font-size: 16px;
    color: #333;
    margin-bottom: 6px;
}

.card-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
}

.card-desc {
    font-size: 12px;
    color: #999;
    line-height: 1.3;
}

.btn-group {
    text-align: left;
}

/* 外层容器：通栏100%宽度、背景底色 */
.steps-wrap {
    width: 100%;
    /* padding: 12px 16px; */
    background-color: #f7f8fa;
    margin-bottom: 20px;
    border-radius: 4px;
    /* 左对齐，不再居中 */
    display: flex;
    justify-content: flex-start;
}

/* 内部步骤条固定40%宽度 */
/deep/ .tiny-step {
    width: 25%;
}

/* 内部元素整体缩小 */
/deep/ .tiny-step .el-step__head {
    width: 16px;
    height: 16px;
}

/deep/ .tiny-step .el-step__line {
    top: 7px;
}

/deep/ .tiny-step .el-step__line-inner {
    height: 1px;
}

/deep/ .tiny-step .el-step__title {
    font-size: 15px;
    color: #999;
}

/deep/ .tiny-step .el-step__icon-inner {
    font-size: 9px;
}

/* 当前进行中 蓝色样式 */
/deep/ .tiny-step .el-step .is-process .el-step__icon {
    /* background: #409eff; */
    border-color: #409eff;
}

/deep/ .tiny-step .el-step .is-process .el-step__title {
    color: #409eff;
    font-weight: 500;
}

/* 已完成步骤 绿色样式 */
/deep/ .tiny-step .el-step .is-finish .el-step__icon {
    /* background: #67c23a; */
    border-color: #67c23a;
}

/deep/ .tiny-step .el-step .is-finish .el-step__line-inner {
    background-color: #67c23a;
}

/deep/ .tiny-step .el-step .is-finish .el-step__title {
    color: #67c23a;
}
</style>
